import { render, staticRenderFns } from "./CompaniesSwitcher.vue?vue&type=template&id=2a0d593c&scoped=true&"
import script from "./CompaniesSwitcher.vue?vue&type=script&lang=ts&"
export * from "./CompaniesSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./CompaniesSwitcher.vue?vue&type=style&index=0&id=2a0d593c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d593c",
  null
  
)

export default component.exports